import { render, staticRenderFns } from "./JwsVehicleStatus.vue?vue&type=template&id=4a72fa22"
import script from "./JwsVehicleStatus.vue?vue&type=script&lang=js"
export * from "./JwsVehicleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports